import type { UnconfirmedContextType } from '@seek/ca-graphql-schema/types';

import type { AppConfig } from 'src/modules/appConfig/types';
import { classifyError } from 'src/modules/error-helper';
import type { ApiClient } from 'src/types';
import * as Schema from 'src/types/graphql';

import {
  Actions as UnconfirmedDataActions,
  fetchUnconfirmedDataSuccess,
  fetchUnconfirmedDataFailure,
} from './actionCreators';

export const makeUnconfirmedDataUpdater = ({
  api: { queryGql },
  appConfig: { language },
}: {
  api: ApiClient;
  appConfig: AppConfig;
}) => ({
  on: (type: string) =>
    type === UnconfirmedDataActions.FETCH_UNCONFIRMED_DATA ||
    type === UnconfirmedDataActions.FETCH_UNCONFIRMED_DATA_START,
  run: ({ contextId }: { contextId: string }) =>
    queryGql({
      query: Schema.HasResumeBeenParsedDocument,
      variables: {
        contextId,
        contextType: 'Application' as UnconfirmedContextType,
        languageCode: language,
      },
      fetchPolicy: 'no-cache',
    }),
  success: fetchUnconfirmedDataSuccess,
  failure: fetchUnconfirmedDataFailure,
  classifyError,
});
